import React from 'react'
import { PaidGiftHeader, GiftDateContainer } from '../styles/gift'
import GiftCode from './GiftCode'
import GiftDate from './GiftDate'

export default ({ purchaseDate, expirationDate, code, type }) => (
  <PaidGiftHeader>
    <GiftDateContainer>
      <GiftDate date={purchaseDate} label="PURCHASE_DATE" />
      {/* {expirationDate &&
        <GiftDate date={expirationDate} label="EXPIRATION_DATE" />
      } */}
    </GiftDateContainer>
    <GiftCode
      type={type}
      code={code}
      label="GIFT_CODE"
    />
  </PaidGiftHeader>
)
